import React, { useState, useEffect } from "react";
import login from "./register.module.css";
import { useForm } from "react-hook-form";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { CiLock, CiMail, CiPhone } from "react-icons/ci";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa6";
import { IoMdArrowRoundBack } from "react-icons/io";
import OTPInput from "react-otp-input";
import { Error, SuccessSwal, warningSwal } from "../../Util/Toast";
import {
    registerUser,
    acceptInvitation,
    generateOtp,
    verifyOtp,
} from "../../Services/APIrequests";
import Logoblue from "../../Assets/login/blue-logo.svg";
import Logo from "../../Assets/KohereHedaer.png";
import useStore from "../../Store";
import Navstyles from "../../Components/Navbar/nav.module.css";

const Register = () => {
    const [showPassword, setShowPassword] = useState(true);
    const [hidePassword, setHidePassword] = useState(true);
    const [inviteToken, setInviteToken] = useState(null);
    const [step, setStep] = useState("form"); // "form" | "otp"
    const [otp, setOtp] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [resendDisabled, setResendDisabled] = useState(false);
    const [timer, setTimer] = useState(0);
    const { Theme, setTheme } = useStore();
    const location = useLocation();
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        watch,
    } = useForm();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("inviteToken");
        if (token) setInviteToken(token);
    }, []);

    // Resend timer
    const startResendTimer = () => {
        setTimer(30);
        setResendDisabled(true);
        const intervalId = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(intervalId);
                    setResendDisabled(false);
                }
                return prev - 1;
            });
        }, 1000);
    };

    const handleRegularRegistration = async (data) => {
        try {
            setPhoneNumber(data.phoneNumber);
            const newUser = 1;
            const res = await generateOtp({ phone: data.phoneNumber, newUser });
            if (res.status === 200) {
                SuccessSwal("OTP Sent", res.data.message);
                setStep("otp");
                startResendTimer();
            } else {
                warningSwal("Failed", res.data.message);
            }
        } catch (error) {
            warningSwal(
                "Error",
                error.response?.data?.message || "Failed to send OTP"
            );
        }
    };

    const handleVerifyOtp = async () => {
        try {
            const res = await verifyOtp({ phone: phoneNumber, otp });
            if (res.status === 200) {
                SuccessSwal("Verified", "OTP verified successfully!");
                await completeRegistration();
            } else {
                warningSwal("Invalid OTP", res.data.message);
            }
        } catch (error) {
            warningSwal(
                "Error",
                error.response?.data?.message || "OTP verification failed"
            );
        }
    };

    const completeRegistration = async () => {
        const data = getValues();
        try {
            let requestBody;
            if (inviteToken) {
                requestBody = { token: inviteToken, email: data.email };
                const res = await acceptInvitation(requestBody);
                if (res.status === 200) {
                    SuccessSwal("Success", res.data.message);

                    navigate("/kohere/Dashboard");
                } else {
                    Error(res.data.message);
                }
            } else {
                requestBody = {
                    name: data.name,
                    email: data.email,
                    phone: data.phoneNumber,
                    password: data.password,
                    confirmPassword: data.confirmpassword,
                };
                const res = await registerUser(requestBody);
                if (res.status === 201) {
                    SuccessSwal("Success", "Registered Successfully");
                    navigate("/kohere/Dashboard");
                } else {
                    Error(res.data.message);
                }
            }
        } catch (error) {
            warningSwal("Error", error.response?.data?.message);
        }
    };

    const handleResend = async () => {
        try {
            const newUser = 1;
            const res = await generateOtp({ phone: phoneNumber, newUser });
            if (res.status === 200) {
                SuccessSwal("OTP Sent", res.data.message);
                startResendTimer();
            } else {
                warningSwal("Failed", res.data.message);
            }
        } catch (error) {
            warningSwal(
                "Error",
                error.response?.data?.message || "Failed to resend OTP"
            );
        }
    };

    const validatePassword = (password) => {
        const minLength = /.{8,}/;
        const hasUpperCase = /[A-Z]/;
        const hasNumber = /[0-9]/;
        const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

        const errors = [];

        if (!minLength.test(password)) {
            errors.push("at least 8 characters long");
        }
        if (!hasUpperCase.test(password)) {
            errors.push("at least one uppercase letter");
        }
        if (!hasNumber.test(password)) {
            errors.push("one number");
        }
        if (!hasSpecialChar.test(password)) {
            errors.push("one special character");
        }

        if (errors.length > 0) {
            return `Password must contain ${errors.join(", ")}`;
        }
        return true;
    };

    const handleBackToForm = () => {
        setStep("form");
        setOtp("");
        setResendDisabled(false);
        setTimer(0);
    };

    // Masked phone number
    const maskedPhone =
        phoneNumber && phoneNumber.length >= 10
            ? phoneNumber.replace(
                  /^(\d{3})(\d{3})(\d{2})(\d{2})$/,
                  "$1 XXX XX $4"
              )
            : "XXX XXX XX XX";

    const onSubmit = (data) => {
        handleRegularRegistration(data);
    };

    const renderFormContent = () => {
        if (step === "otp") {
            return (
                <div className={login.otp_container}>
                    <div className={login["form-control"]}>
                        <label className={login.otp_label}>
                            Enter Verification Code
                        </label>
                        <p className={login.otp_description}>
                            We have sent an SMS verification code to:
                            <br />
                            <span className={login.phone_masked}>
                                {maskedPhone}
                            </span>
                        </p>

                        <div className={login.otp_input_wrapper}>
                            <OTPInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={4}
                                inputType={"tel"}
                                shouldAutoFocus={true}
                                containerStyle={login["otp-input-container"]}
                                inputStyle={login["otp-input"]}
                                renderInput={(props) => (
                                    <input
                                        {...props}
                                        className={login.otpInput}
                                    />
                                )}
                            />
                        </div>
                    </div>

                    <button
                        onClick={handleVerifyOtp}
                        type="button"
                        className={login.verify_btn}
                        disabled={otp.length !== 4}>
                        Verify OTP
                    </button>

                    <button
                        disabled={resendDisabled}
                        onClick={handleResend}
                        type="button"
                        className={login.resend_btn}>
                        {resendDisabled
                            ? `Resend OTP (${timer}s)`
                            : "Resend OTP"}
                    </button>
                </div>
            );
        }

        return (
            <form
                onSubmit={handleSubmit(onSubmit)}
                className={login.registration_form}>
                {/* Form Fields */}
                <div className={login.form_fields}>
                    <div className={login["form-control"]}>
                        <label>Full Name</label>
                        <div className={login.input_container}>
                            <input
                                type="text"
                                placeholder="Enter your full name"
                                {...register("name", {
                                    required: "Name is required!",
                                })}
                            />
                            <FaRegUser className={login.input_icon} />
                        </div>
                        {errors.name && (
                            <p className={login.error}>{errors.name.message}</p>
                        )}
                    </div>

                    <div className={login["form-control"]}>
                        <label>Email Address</label>
                        <div className={login.input_container}>
                            <input
                                type="email"
                                placeholder="Enter your email address"
                                {...register("email", {
                                    required: "Email is required!",
                                })}
                            />
                            <CiMail className={login.input_icon} />
                        </div>
                        {errors.email && (
                            <p className={login.error}>
                                {errors.email.message}
                            </p>
                        )}
                    </div>

                    <div className={login["form-control"]}>
                        <label>Phone Number</label>
                        <div className={login.input_container}>
                            <input
                                type="tel"
                                placeholder="Enter your phone number"
                                {...register("phoneNumber", {
                                    required: "Phone number is required!",
                                    pattern: {
                                        value: /^\+?[0-9]{10,14}$/,
                                        message: "Enter a valid phone number",
                                    },
                                })}
                            />
                            <CiPhone className={login.input_icon} />
                        </div>
                        {errors.phoneNumber && (
                            <p className={login.error}>
                                {errors.phoneNumber.message}
                            </p>
                        )}
                    </div>

                    <div className={login["form-control"]}>
                        <label>Password</label>
                        <div className={login.input_container}>
                            <input
                                type={hidePassword ? "password" : "text"}
                                placeholder="Create a password"
                                {...register("password", {
                                    required: "Password is required!",
                                    validate: validatePassword,
                                })}
                            />
                            {/* <CiLock className={login.input_icon} /> */}
                            <button
                                type="button"
                                className={login.password_toggle}
                                onClick={() => setHidePassword(!hidePassword)}>
                                {hidePassword ? <IoEyeOff /> : <IoEye />}
                            </button>
                        </div>
                        {errors.password && (
                            <p className={login.error}>
                                {errors.password.message}
                            </p>
                        )}
                    </div>

                    <div className={login["form-control"]}>
                        <label>Confirm Password</label>
                        <div className={login.input_container}>
                            <input
                                type={showPassword ? "password" : "text"}
                                placeholder="Confirm your password"
                                {...register("confirmpassword", {
                                    required: "Please confirm your password!",
                                    validate: (value) => {
                                        const password = watch("password");
                                        return (
                                            !password ||
                                            value === password ||
                                            "Passwords do not match"
                                        );
                                    },
                                })}
                            />
                            {/* <CiLock className={login.input_icon} /> */}
                            <button
                                type="button"
                                className={login.password_toggle}
                                onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <IoEyeOff /> : <IoEye />}
                            </button>
                        </div>
                        {errors.confirmpassword && (
                            <p className={login.error}>
                                {errors.confirmpassword.message}
                            </p>
                        )}
                    </div>
                </div>

                <button type="submit" className={login.submit_btn}>
                    Create Account
                </button>
            </form>
        );
    };

    return (
        <div className={login.container}>
            <div className={login.form_wrapper}>
                <div className={login.LOGO_imagecontainer}>
                    <img
                        src={Theme === "dark" ? Logo : Logoblue}
                        alt="logo"
                        className={Navstyles.img}
                    />
                </div>

                <div className={login.header}>
                    <h1
                        className={login.title}
                        style={{ display: "flex", gap: "5rem" }}>
                        {step === "otp" && (
                            <button
                                onClick={handleBackToForm}
                                type="button"
                                className={login.close_btn}
                                title="Back to form">
                                <IoMdArrowRoundBack />
                            </button>
                        )}
                        {step === "otp"
                            ? "Verify Your Phone"
                            : "Create Account"}
                    </h1>
                    <p className={login.subtitle}>
                        {step === "otp"
                            ? "Enter the verification code we sent to your phone"
                            : "Join us and start your journey today"}
                    </p>
                </div>

                <div className={login.form_container}>
                    {renderFormContent()}
                </div>

                {step === "form" && (
                    <div className={login.footer}>
                        <p className={login.login_link}>
                            Already have an account?{" "}
                            <NavLink to="/login" className={login.link}>
                                Sign In
                            </NavLink>
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Register;
